import { getCookie } from "./function";

// const main_url = "http://103.109.200.56:5002"; // was
// const main_url = "http://192.168.0.87:5002"; // local kantor
export const main_url = process.env.REACT_APP_BASE_API; // forward local kantor

// export const BASE_URL = main_url;
// export const BASE_URL = "http://103.109.200.56:5002";

const fetchApi = async (path, method, token, raw) => {
  if (!raw) {
    raw = {};
  }
  let tokene;
  let header;
  if (token) {
    tokene = getCookie("token");
    header = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${tokene}`,
    };
  } else {
    header = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
  }
  let option;
  if (method.toLowerCase() === "get") {
    option = {
      method: method,
      headers: header,
      redirect: "follow",
      referrerPolicy: "no-referrer",
    };
  } else if (method.toLowerCase() === "get_blob") {
    option = {
      method: "GET",
      headers: header,
      redirect: "follow",
      referrerPolicy: "no-referrer",
      responseType: "blob",
    };
  } else {
    option = {
      method: method,
      headers: header,
      redirect: "follow",
      body: JSON.stringify(raw),
      referrerPolicy: "no-referrer",
    };
  }
  return fetch(`${main_url}/${path}`, option);
};
const fetchApiUpload = async (path, method, raw) => {
  const tokene = getCookie("token");
  const header = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${tokene}`,
  };
  const option = {
    method: method,
    headers: header,
    redirect: "follow",
    body: JSON.stringify(raw),
    referrerPolicy: "no-referrer",
  };
  return fetch(`${main_url}/${path}`, option);
};

const getImage = (url) => {
  return `${main_url}/api/Bridge/image/${url}`;
};
const getImageHistory = (url) => {
  return `${main_url}/api/ThresholdHistory/image/${url}`;
};

export { fetchApi, fetchApiUpload, getImage, getImageHistory };
